<template>
  <div>
    <section class="faq-page__wrapper clearfix">
      <header class="faq-page__header">
        <h1>Frequently Asked Questions</h1>
        <p>
          This list contains the most frequented questions based on your ongoing
          feedback on the forums and social media.
        </p>
      </header>

      <faq class="faq" :faqs="faqs" />

      <footer class="faq-page__footer">
        <p>
          Can't find the answers you're looking for? You can contact us on
          support@bistudio.com or our social media.
        </p>
      </footer>
    </section>
    <subscription />
  </div>
</template>

<script>
import { mapActions } from "vuex";

import { Faq } from "@bistudio/dayz-frontend-components";
import Subscription from "../partials/Subscription/Subscription.vue";

export default {
  components: {
    faq: Faq,
    subscription: Subscription
  },
  data() {
    return {
      faqs: []
    };
  },
  metaInfo: {
    title: "FAQ."
  },
  methods: {
    ...mapActions("faq", {
      getFaqs: "getList"
    }),
    async loadData() {
      this.$store.commit("settings/setLoading", true);

      this.faqs = await this.getFaqs();

      this.$nextTick(function() {
        this.$store.dispatch("settings/setLoading", false);
      });
    }
  },
  created() {
    this.loadData();
  }
};
</script>
